// getters
const getters = {
  getLogin: (state) => state.login,
  getShipmentDetail: (state) => state.shipmentDetail,
  getShipmentBatchDetail: (state) => state.getShipmentBatchDetail,
};

export default getters;
